// src/sdk/Auth.js
const __AUTH = {
  env: {},
  loginInfo: null,
};

(() => {
    init();
})();

/** 通用 POST 请求 */
async function post(url, data) {
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
}

/** 初始化 env，并持久化到 localStorage */
function configEnv(env) {
  __AUTH.env = env;

  __AUTH.env.aws_cognito_login =
    `${env.aws_cognito_domain}/login?response_type=code&client_id=${env.aws_cognito_clientId}&redirect_uri=${env.aws_cognito_redirectUri}`;

  __AUTH.env.aws_cognito_logout =
    `${env.aws_cognito_domain}/logout?client_id=${env.aws_cognito_clientId}&logout_uri=${env.aws_cognito_logoutUri}`;

  __AUTH.env.token_exchange_api =
    `${env.uds_domain}/auth/api/v2/token`;

    __AUTH.env.token_refresh_api =
    `${env.uds_domain}/auth/api/v2/token/refresh`;

  __AUTH.env.logout_api =
    `${env.uds_domain}/auth/api/v2/logout`;

    localStorage.setItem("AUTH_ENV", JSON.stringify(env));
}

function getEnv() {
  return __AUTH.env;
}

function init(env) {
    let initEnv = null;
    let authConf = null;
    let authEnvJson = null;
    if (!env) {
       authEnvJson = localStorage.getItem("AUTH_ENV");
       if (!authEnvJson) {
          initEnv = window.location.host.split(".")[0];
       } else {
          authConf = JSON.parse(authEnvJson);
       }
    } else {
       initEnv = env;
    }
    if (initEnv) {
      switch (initEnv) {
          case "dev":
              authConf = window.__AUTH_CONF__.dev;
              break;
          case "qa":
              authConf = window.__AUTH_CONF__.qa;
              break;
          default:
              authConf = window.__AUTH_CONF__.japan;
        }
    }
    configEnv(authConf);

    const login = localStorage.getItem("ucloud_login_info");
    if (login) {
        __AUTH.loginInfo = JSON.parse(login);
    }
}

/** login */
async function loginWithCallback(callback) {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  if (!code) return;

  try {
    const rsp = await post(__AUTH.env.token_exchange_api, {
      type: "login",
      code,
      redirect_uri: __AUTH.env.aws_cognito_redirectUri,
    });

    if (rsp.code === 0) {
      __AUTH.loginInfo = rsp.data;
      localStorage.setItem("ucloud_login_info", JSON.stringify(rsp.data));
      callback?.success?.();
      window.location.href = __AUTH.env.login_ok_url;
    } else {
      __AUTH.loginInfo = null;
      localStorage.clear();
      callback?.fail?.();
      window.location.href = __AUTH.env.login_fail_url;
    }
  } catch (e) {
    console.error("login error", e);
    __AUTH.loginInfo = null;
    localStorage.clear();
    callback?.fail?.();
    window.location.href = __AUTH.env.login_fail_url;
  }
}

/** refresh token */
async function refreshToken(callback) {
  try {
    const rsp = await post(
      __AUTH.env.token_refresh_api, 
      {}, 
      {withCredentials: true
      });

    if (rsp.code === 0) {
      __AUTH.loginInfo.accessToken = rsp.data.accessToken;
      localStorage.setItem("ucloud_login_info", JSON.stringify(__AUTH.loginInfo));
      setNextTokenRefresh();
      callback?.success?.();
    } else {
      callback?.fail?.();
      window.location.href = __AUTH.env.login_fail_url;
    }
  } catch (e) {
    callback?.fail?.();
    window.location.href = __AUTH.env.login_fail_url;
  }
}

function setNextTokenRefresh() {
    const delay = (__AUTH.loginInfo.accessToken.expireTimestamp - 2 * 60) * 1000 - Date.now();
    setTimeout(async () => {
        await refreshToken();
        console.log("token refreshed");
    }, delay);
}    


/** logout */
async function logoutWithCallback() {
  try {
    await post(__AUTH.env.logout_api, {});
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = __AUTH.env.aws_cognito_logout;
  } catch (e) {
    console.error("logout error", e);
  }
}

/** getters */
function getLoginInfo() {
  return __AUTH.loginInfo;
}

function getAccessToken() {
  return __AUTH.loginInfo?.accessToken?.value;
}

function getRefreshToken() {
  return __AUTH.loginInfo?.refreshToken?.value;
}

function getUlabUser() {
  return __AUTH.loginInfo?.user;
}

/** check token expire */
function isAccessTokenExpired() {
  const now = Date.now();
  return !__AUTH.loginInfo || __AUTH.loginInfo.accessToken.expireTimeStamp < now;
}

/** 导出全局单例 Auth */
const Auth = {
  configEnv,
  getEnv,
init,
  loginWithCallback,
  refreshToken,
  logoutWithCallback,
  getLoginInfo,
  getAccessToken,
  getRefreshToken,
  getUlabUser,
  isAccessTokenExpired,
  setNextTokenRefresh
};

export default Auth;